import _createForOfIteratorHelper from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _slicedToArray from "/builds/JohnLewisPartnership/digital/services/online-checkout/checkout-ui/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { VOID, PRIMITIVE, ARRAY, OBJECT, DATE, REGEXP, MAP, SET, ERROR, BIGINT } from './types.js';
var env = typeof self === 'object' ? self : globalThis;
var deserializer = function deserializer($, _) {
  var as = function as(out, index) {
    $.set(index, out);
    return out;
  };
  var _unpair = function unpair(index) {
    if ($.has(index)) return $.get(index);
    var _$index = _slicedToArray(_[index], 2),
      type = _$index[0],
      value = _$index[1];
    switch (type) {
      case PRIMITIVE:
      case VOID:
        return as(value, index);
      case ARRAY:
        {
          var arr = as([], index);
          var _iterator = _createForOfIteratorHelper(value),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var _index = _step.value;
              arr.push(_unpair(_index));
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return arr;
        }
      case OBJECT:
        {
          var object = as({}, index);
          var _iterator2 = _createForOfIteratorHelper(value),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var _step2$value = _slicedToArray(_step2.value, 2),
                key = _step2$value[0],
                _index2 = _step2$value[1];
              object[_unpair(key)] = _unpair(_index2);
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          return object;
        }
      case DATE:
        return as(new Date(value), index);
      case REGEXP:
        {
          var source = value.source,
            flags = value.flags;
          return as(new RegExp(source, flags), index);
        }
      case MAP:
        {
          var map = as(new Map(), index);
          var _iterator3 = _createForOfIteratorHelper(value),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _step3$value = _slicedToArray(_step3.value, 2),
                _key = _step3$value[0],
                _index3 = _step3$value[1];
              map.set(_unpair(_key), _unpair(_index3));
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          return map;
        }
      case SET:
        {
          var set = as(new Set(), index);
          var _iterator4 = _createForOfIteratorHelper(value),
            _step4;
          try {
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              var _index4 = _step4.value;
              set.add(_unpair(_index4));
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          return set;
        }
      case ERROR:
        {
          var name = value.name,
            message = value.message;
          return as(new env[name](message), index);
        }
      case BIGINT:
        return as(BigInt(value), index);
      case 'BigInt':
        return as(Object(BigInt(value)), index);
      case 'ArrayBuffer':
        return as(new Uint8Array(value).buffer, value);
      case 'DataView':
        {
          var _Uint8Array = new Uint8Array(value),
            buffer = _Uint8Array.buffer;
          return as(new DataView(buffer), value);
        }
    }
    return as(new env[type](value), index);
  };
  return _unpair;
};

/**
 * @typedef {Array<string,any>} Record a type representation
 */

/**
 * Returns a deserialized value from a serialized array of Records.
 * @param {Record[]} serialized a previously serialized value.
 * @returns {any}
 */
export var deserialize = function deserialize(serialized) {
  return deserializer(new Map(), serialized)(0);
};